import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { PATHS } from '../AppConstants';
import ExpenseSeo from './expenseSeo';
import ResourcePage from './resource';
import { isLoggedIn } from 'UtilityComponents/Util';

const SeoApp = ({ isMobile, isLoggedInUserServer }) => {
	const isLoggedInUser = isLoggedIn() || isLoggedInUserServer;
	return (
		<Switch>
			<Route exact path={PATHS.EXPENSE_SEO}>
				<ExpenseSeo isMobLoginRedirect={false} isLoggedInUser={isLoggedInUser} isMobile={isMobile} />
			</Route>
			<Route exact path={PATHS.RESOURCE_PAGE}>
				<ResourcePage isMobLoginRedirect={false} isMobile={isMobile} isLoggedInUser={isLoggedInUser} />
			</Route>
		</Switch>
	);
};
export default SeoApp;
